import React from 'react'
import styled from 'styled-components'
import SearchBookResponse from './SearchBookResponse'
import { Card } from 'react-bootstrap'
import RowSpacer from '../../../common/styles/RowSpacer'
import { useNavigate } from 'react-router-dom'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import BooksitoutIcon from '../../../config/BooksitoutIcon'
import ColorConfig from '../../../config/ColorConfig'
import { Author } from '../../../common/Author'
import BooksitoutImages from '../../../images/BooksitoutImages'

interface Props {
	book: SearchBookResponse
	onClick?: () => void
	url?: string
	height?: number
}

const SearchBookCard: React.FC<Props> = ({ book, onClick, url, height }) => {
	const navigate = useNavigate()

	const defaultOnClick = () => {
		navigate(`/search/${book.isbn13}`)
	}

	if (url != null) {
		return (
			<a href={url} className={'p-0 m-0'}>
				<Container>
					<Card className="clickable" onClick={onClick}>
						<CardBodyContentContainer height={150} backgroundColorType={'card-card'}>
							{book.status !== 'NOT_ADDED' && (
								<AddButtonContainer>
									<CheckMark />
								</AddButtonContainer>
							)}

							<ContentContainer>
								<CoverWrapper><Cover src={book.coverUrl ?? BooksitoutImages.Placeholder.bookCover} alt={book.title} height={height ?? 200} /></CoverWrapper>
								<RowSpacer size={12.5} />

								<Title>{book.title}</Title>
								<RowSpacer size={2.5} />

								<Author>{book.authors == '' ? '-' : book.authors}</Author>
							</ContentContainer>
						</CardBodyContentContainer>
					</Card>
				</Container>
			</a>
		)
	}

	return (
		<Card className="clickable" onClick={onClick || defaultOnClick}>
			{book.status !== 'NOT_ADDED' && (
				<AddButtonContainer>
					<CheckMark />
				</AddButtonContainer>
			)}

			<CardBodyContentContainer height={150} style={{ opacity: book.status !== 'NOT_ADDED' ? '60%' : '100%' }} backgroundColorType={'card-card'}>
				<ContentContainer>
					<CoverWrapper><Cover src={book.coverUrl ?? BooksitoutImages.Placeholder.bookCover} alt={book.title} height={height ?? 200} /></CoverWrapper>
					<RowSpacer size={10} />

					<Title>{book.title}</Title>
					<Author>{book.authors == '' ? '-' : book.authors}</Author>
				</ContentContainer>
			</CardBodyContentContainer>
		</Card>
	)
}

const Container = styled.a`
	padding-left: 2.5px;
	padding-right: 2.5px;

	height: 350px;
`

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	width: 100%;
`

const CoverWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 150px;
	overflow: hidden;
	border-radius: 6px;
	width: fit-content;
	margin: 0 auto;
`

const Cover = styled.img`
	max-height: 100%;
	object-fit: contain;
`

const Title = styled.h1.attrs({
	className: 'clamp-1-line',
})`
	font-size: 15px;
	text-align: center;
`

const AddButtonContainer = styled.div`
	position: absolute;
	right: 10px;
	top: 5px;
`

const CheckMark = styled(BooksitoutIcon.check)`
	font-size: 25px;
	color: ${ColorConfig.Primary};
`

export default SearchBookCard
